import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';
import MuiGrid from '@material-ui/core/Grid';
import RecoupAccountForm from './FormComponents/RecoupAccountForm';
import { useQuery } from 'react-query';
import * as API from 'api';
import MuiCircularProgress from '@material-ui/core/CircularProgress';

import ViewWrapper from 'views/ViewWrapper';
const RecoupAccounts = API.RecoupAccounts();

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
});
function EditRecoupAccounts({ ...props }) {
  const history = useHistory();
  const {
    classes,
    match: {
      params: { id },
    },
  } = props;

  const {
    data: account,
    status: loadingAccountStatus,
    refetch,
  } = useQuery(['recoup-account', id], () => RecoupAccounts.getById(id));

  function goBack() {
    history.push('/recoupment-accounts');
  }

  async function saveRecoupAccount(formData) {
    const data = await RecoupAccounts.patch(id, formData);
    await refetch();
    return data;
  }

  return (
    <ViewWrapper>
      <MuiPaper className={classes.paper}>
        <MuiGrid container spacing={1}>
          <MuiGrid item xs={12}>
            <MuiTypography variant="h6">Edit Recoupment Account</MuiTypography>
          </MuiGrid>
          {loadingAccountStatus !== 'success' ? (
            <MuiCircularProgress className={classes.loadWrapper} />
          ) : (
            <RecoupAccountForm goBack={goBack} saveRecoupAccount={saveRecoupAccount} account={account} />
          )}
        </MuiGrid>
      </MuiPaper>
    </ViewWrapper>
  );
}

export default withStyles(styles)(EditRecoupAccounts);
